/**
 * Which units a datapoint's unit can be relabelled to in edit mode.
 *
 * There is no backend "allowed units" concept — `FoundationTargetPoint` carries exactly one `unit` string
 * per datapoint, and a figure arriving in a different unit is reported as a warning rather than matched
 * against a list of acceptable alternatives (see backend/CLAUDE.md's "Target structure tables" section).
 * So this is a small, hardcoded, frontend-only lookup — the same two families the design brief's reference
 * prototype hardcodes in its own JS — kept in its own file so it is easy to find and replace once (if ever)
 * a real backend concept exists.
 *
 * TODO (flagged in the design brief, open question for product): changing the unit here only RELABELS the
 * stored number — it does not convert it. "3,300 tCO2e" edited to "ktCO2e" becomes "3,300 ktCO2e", a figure
 * 1000x too large. Deliberate for this pass; revisit once product decides whether a unit change should
 * convert the value.
 */
export const UNIT_FAMILIES = {
  tCO2e: ["tCO2e", "ktCO2e", "MtCO2e", "kgCO2e"],
  MWh: ["MWh", "kWh", "GWh", "GJ"],
};

/**
 * The family a unit belongs to, or null for a fixed unit (e.g. "%") with no alternatives.
 *
 * A unit matches a family if it's a member of that family's list — not just the family's own key — so a
 * row already saved as "ktCO2e" still offers the full tCO2e family rather than looking fixed.
 */
export function familyFor(unit) {
  if (!unit) return null;
  const family = Object.values(UNIT_FAMILIES).find((options) => options.includes(unit));
  return family || null;
}
